import { render, staticRenderFns } from "./select-question-direction.vue?vue&type=template&id=83e0b18a&"
import script from "./select-question-direction.vue?vue&type=script&lang=js&"
export * from "./select-question-direction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports